import { render, staticRenderFns } from "./SpinnerBackdrop.vue?vue&type=template&id=7540e9ca&scoped=true&"
import script from "./SpinnerBackdrop.vue?vue&type=script&lang=js&"
export * from "./SpinnerBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerBackdrop.vue?vue&type=style&index=0&id=7540e9ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7540e9ca",
  null
  
)

export default component.exports